// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Icon/icon.sass
// module id = 346
// module chunks = 0